// https://stackoverflow.com/questions/1144783/how-do-i-replace-all-occurrences-of-a-string-in-javascript
export const escapeRegExp = (string: string): string => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
};

export const replaceAllPolyfill = (str: string, find: string, replace: string): string => {
  return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
};

if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function (search, replacement) {
    if (typeof search === 'string' && typeof replacement === 'string') {
      return this.split(search).join(replacement);
    } else if (search instanceof RegExp && typeof replacement === 'function') {
      const flags = search.flags.replace('g', ''); // Remove global flag
      const newRegExp = new RegExp(search.source, flags + 'g');

      return this.replace(newRegExp, replacement);
    } else {
      throw new TypeError('First argument must be a string or a RegExp');
    }
  };
}
